export default __webpack_public_path__ + "static/media/deco-result4.7a4b8161.png";